import React, { Component } from "react";
import { toast } from "react-toastify";
import PinInput from "react-pin-input";

import http from "../services/httpService";
import auth from "../services/authService";
import Spinner from "./common/spinner";

class TwofaForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      token: "",
      errors: {},
      loading: false,
    };
  }

  onChange = (token) => {
    this.setState({ token });
  };

  doSubmit = async () => {
    const tokenKey = "token";
    // call the server
    try {
      this.setState({ loading: true });
      const { token } = this.state;
      const userAuthToken = this.props.location.jwt;
      http.setJwt(userAuthToken);
      console.log(userAuthToken);

      this.setState({ loading: false });
      // localStorage.setItem(tokenKey, userAuthToken);
      // const { state } = this.props.location;
      // window.location = state ? state.from.pathname : '/';
      // this.props.history.push('/');
      // console.log('login succesful')

      const result = await http.post("/auth/admin/twofa/verify", {
        email: this.props.location.email,
        code: token,
      });

      const { data: response } = result;
      console.log(response);

      if (response.error == false) {
        localStorage.setItem(tokenKey, userAuthToken);
        const { state } = this.props.location;
        window.location = state ? state.from.pathname : "/";
        this.props.history.push("/");
        console.log("login succesful");
      } else {
        toast(response.message);
        this.setState({ loading: false });
      }
    } catch (ex) {
      if (ex.response) {
        //console.log(ex.response);
        toast(ex.response.data.message);
        this.setState({ loading: false });
      }
    }
  };

  render() {
    const { token, loading } = this.state;
    const rowStyle = {
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "space-between",
      padding: "2%",
      fontSize: "14px",
    };
    const rowWrapperStyle = {
      display: "table",
      width: "100%",
    };
    return (
      <div className="row">
        <div className="col-md-4 offset-md-4">
          <div className="mx-auto mt-5" style={{ border: 0, borderRadius: 0 }}>
            <div className="card-body">
              <div className="text-center mb-4">
                <h4
                  style={{
                    borderBottom: 0,
                    marginTop: 10 + "%",
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  2-Step Authentication
                </h4>
                <p>
                  You are one step away from completing your login to the
                  dashboard
                </p>
              </div>

              <div className="form-row">
                <div style={rowWrapperStyle}>
                  <div>
                    <div style={rowStyle}>
                      <div className="text-center" style={{ flex: "6 6 0px" }}>
                        <label
                          style={{
                            display: "block",
                            color: "black",
                            fontWeight: "bold",
                            fontSize: 12 + "px",
                          }}
                          htmlFor="email"
                        >
                          Enter OTP Sent to your mobile phone
                        </label>
                        <PinInput
                          length={6}
                          onChange={this.onChange}
                          type="numeric"
                          style={{ paddingBottom: "10px" }}
                          inputStyle={{ borderColor: "gray" }}
                          inputFocusStyle={{ borderColor: "blue" }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <button
                disabled={!loading ? !token : loading}
                onClick={this.doSubmit}
                className="btn btn-invest btn-block"
              >
                {loading && <Spinner message="Verification in progress..." />}
                {loading && <span>Verification in progress...</span>}
                {!loading && <span>Verify</span>}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TwofaForm;
